"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getData = getData;

var _ApiUtils = require("@/utils/ApiUtils");

var _axios = _interopRequireDefault(require("axios"));

var AGRUPACIONES_API = process.env.VUE_APP_CONSULTAS_URL + '/agrupacion';

function getData() {
  var promise = _axios.default.get("".concat(AGRUPACIONES_API, "/activas")).catch(function (error) {
    return (0, _ApiUtils.mapError)(error);
  });

  return promise.then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
}